import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './auth.module';
import { technicalManagement } from './technical_management.module';
import { serviceOrdersIndicator } from './service_orders_indicator.module';
import { tabs } from './tabs.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    technicalManagement,
    serviceOrdersIndicator,
    tabs,
  }
});
